import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=0939daa8"
import script from "./TransactionTable.vue?vue&type=script&lang=js"
export * from "./TransactionTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionTable.vue?vue&type=style&index=0&id=0939daa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports